import React from 'react';
import '../css/SystemIntegrator.css';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
// import Modal from 'react-modal';
import DoughnutChart from './DoughnutChart';
import Sorting from './Sorting';
import DistributorView from './DistributorView';
// import DistributorEdit from './DistributorEdit';
import UserAddNew from './UserAddNew';
import UserEdit from './UserEdit';
import editIcon from './../assets/images/edit.svg';
import SearchBar from './SearchBar';
import Style from 'style-it';
import { Tooltip } from 'react-tooltip';
import * as ActionTypes from '../actions/types';
import { connect } from 'react-redux';
import SiTotalOkasBoxes from './SiTotalOkasBoxes';
import Loader from './Loader';
import DistributorProjects from './DistributorProjects';
import { Switch } from '@mui/material'; // At the top of your file
import { is_allowed } from '../utilitis';



//system intregator dashboard page.

const customStylesDelete = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: '40%',
        minHeight: '40%',
        overflow: 'auto',
        padding: '2%',
    }
};

const styles = theme => ({
    root: {
        display: 'flex',
        // flexWrap: 'wrap',
    },
    formControl: {
        // margin: theme.spacing.unit,
        minWidth: 120,
        width: '100%',
        border: 'none'
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2,
        width: '100%',
    },
});
class User extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modalIsOpenAddSI: false,
            modalIsOpenAddSIView: false,
            modalIsOpenSIProject: false,
            modalIsOpenOkasBoxes: false,
            modalIsOpenAddSIEdit: false,
            modalIsOpenDelete: false,
            modalIsOpenDeleteSuccess: false,
            boxesBySi: [],
            userData: [],
            actualData: [],
            searchValue: '',
            siProjectAddress: [],
            currentViewAllProjects: [],
            currentViewAllBoxes: [],
            siTotalProjectPieChart: 0,
            siTotalBoxesPieChart: 0,
            selectedLocation: '',
            sortingStatus: {
                sortingName: '',
                defaultDown: true
            },
            loader: true,
            snackbarActive: false,
            snackbarMessage: ''
        };
        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.closeModalDelete = this.closeModalDelete.bind(this);
    }

    openModal() {
        this.setState({
            modalIsOpenAddSI: false
        }, () => {
            this.setState({
                modalIsOpenAddSI: true
            })
        })
    }

    afterOpenModal() {
        // references are now sync'd and can be accessed.
        // this.subtitle.style.color = '#f00';
    }

    closeModal() {
        this.setState({ modalIsOpenAddSI: false });
    }

    closeModalDelete() {
        this.setState({
            modalIsOpenDelete: false
        });
    }

    restoreData = (data) => {
        this.setState({
            userData: data,
        })
    }


    resetSearchBar = () => {
        this.props.searchBarActivate(false)
    }


    sortingFunc = (type, searchValue) => {
        if (type !== 'search') {
            if (this.state.sortingStatus.sortingName === type) {
                this.setState({
                    sortingStatus: {
                        sortingName: type,
                        defaultDown: !this.state.sortingStatus.defaultDown
                    },
                }, () => {
                    if (this.state.sortingStatus.sortingName === type && this.state.sortingStatus.defaultDown) {
                        Sorting(this.restoreData, type, this.state.userData.sort());
                    } else if (this.state.sortingStatus.sortingName === type && !this.state.sortingStatus.defaultDown) {
                        Sorting(this.restoreData, 'reverse', this.state.userData.sort());
                    }
                })
            } else {
                this.setState({
                    sortingStatus: {
                        sortingName: type,
                        defaultDown: true
                    },
                }, () => {
                    if (this.state.sortingStatus.sortingName === type && this.state.sortingStatus.defaultDown) {
                        Sorting(this.restoreData, type, this.state.userData.sort());
                    } else if (this.state.sortingStatus.sortingName === type && !this.state.sortingStatus.defaultDown) {
                        Sorting(this.restoreData, 'reverse', this.state.userData.sort());
                    }
                })
            }
        } else if (type === 'search') {
            type = 'search';
            Sorting(this.restoreData, type, this.state.actualData, searchValue);
        } else {
            type = 'reverse';
            Sorting(this.restoreData, type, this.state.actualData);
        }
    }



    ActivateSIModel = (e) => {
        if (this.state.modalIsOpenAddSI) {
            return <UserAddNew activeModal={true} closeAllModal={this.closeAllModal.bind(this)} />
        } else {
            return null
        }
    }

    ActivateSiModelView = (e) => {
        if (this.state.modalIsOpenAddSIView) {
            return <DistributorView activeModal={true} userCurrentData={this.state.userCurrentData} closeAllModal={this.closeAllModal.bind(this)} />
        } else {
            return null
        }
    }

    ActivateUserModelEdit = (e) => {
        if (this.state.modalIsOpenAddSIEdit) {
            return <UserEdit activeModal={true} userCurrentData={this.state.userCurrentData} closeAllModal={this.closeAllModal.bind(this)} />
        } else {
            return null
        }
    }

    componentDidMount() {
        this.resetSearchBar()
        this.fetchUsers();
    }

    onAddClickHandlerPUT(type, toggleData = null) {
        const { allusers } = this.state;

        if (toggleData) {
            const { user_email, currentStatus } = toggleData;
            const newStatus = currentStatus === 1 ? 0 : 1;

            this.setState({ loader: true });

            fetch('/cloud/addUsers/', {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': localStorage.getItem('csrftoken'),
                },
                body: JSON.stringify({ user_email, status: newStatus }),
            })
                .then(async (response) => {

                    if (response.status === 403) {
                        window.location = "/login/session-timeout";
                        throw new Error('Session expired');
                    }

                    if (!response.ok) {
                        let errorMessage = 'Failed to update status';
                        try {
                            const errData = await response.json();
                            if (errData && errData.message) {
                                errorMessage = errData.message;
                            }
                        } catch (err) {
                        }
                        throw new Error(errorMessage);
                    }

                    const data = await response.json();
                    return data;
                })
                .then(async (data) => {

                    try {
                        alert("✅ Success! Your action was completed successfully")
                        window.location.reload();

                        // this.fetchUsers();
                    } catch (err) {
                        //   console.error('Error in getallrealdata():', err);
                        // Optionally: You can still proceed or show alert here:
                        // alert('Warning: failed to refresh data after update.');
                    }

                })
                .catch((error) => {
                    this.setState({ loader: false });
                    alert(`Error updating user status. ${error.message || 'Please try again.'}`);
                });

            return;
        }

        // Handle other add/edit logic...
    }

    renderTotalProject = () => {
        if (this.state.modalIsOpenSIProject) {
            return <DistributorProjects activeModal={true} userCurrentData={this.state.userCurrentData} siAllProjectData={this.state.currentViewAllProjects} closeAllModal={this.closeAllModal.bind(this)} />
        } else {
            return null
        }
    }

    renderTotalBoxes = () => {
        if (this.state.modalIsOpenOkasBoxes) {
            return <SiTotalOkasBoxes activeModal={true} userCurrentData={this.state.userCurrentData} SiTotalOkasBoxes={this.state.currentViewAllBoxes} closeAllModal={this.closeAllModal.bind(this)} />
        } else {
            return null
        }
    }


    fetchUsers = () => {
        this.setState({
            loader: true
        })
        var tokenStored = localStorage.getItem('token');
        tokenStored = `Token ${tokenStored}`;
        var headers = {
            'Content-Type': 'application/json',
            "Access-Control-Allow-Origin": "*",
            'X-CSRFToken': localStorage.getItem('csrftoken'),
            'Authorization': tokenStored
        }
        fetch('/cloud/addUsers/', {
            method: "GET",
            headers: headers,
        })
            .then(response => {
                if (response.status === 403) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('csrftoken');
                    localStorage.removeItem('auth');
                    window.location.href = '/session-timeout'
                } else {
                    return response.json()
                }
            })
            .then(data => {
                this.setState({
                    userData: data,
                    actualData: data,
                    loader: false
                })
            })
            .catch((err) => {
                console.log(err)

            })
    }

    restoreData = (data) => {
        this.setState({
            userData: data
        })
    }
    sortingFunc = (type, searchValue) => {
        if (type !== 'search') {
            if (this.state.sortingStatus.sortingName === type) {
                this.setState({
                    sortingStatus: {
                        sortingName: type,
                        defaultDown: !this.state.sortingStatus.defaultDown
                    },
                }, () => {
                    if (this.state.sortingStatus.sortingName === type && this.state.sortingStatus.defaultDown) {
                        Sorting(this.restoreData, type, this.state.userData.sort());
                    } else if (this.state.sortingStatus.sortingName === type && !this.state.sortingStatus.defaultDown) {
                        Sorting(this.restoreData, 'reverse', this.state.userData.sort());
                    }
                })
            } else {
                this.setState({
                    sortingStatus: {
                        sortingName: type,
                        defaultDown: true
                    },
                }, () => {
                    if (this.state.sortingStatus.sortingName === type && this.state.sortingStatus.defaultDown) {
                        Sorting(this.restoreData, type, this.state.userData.sort());
                    } else if (this.state.sortingStatus.sortingName === type && !this.state.sortingStatus.defaultDown) {
                        Sorting(this.restoreData, 'reverse', this.state.userData.sort());
                    }
                })
            }
        } else if (type === 'search') {
            type = 'search';
            Sorting(this.restoreData, type, this.state.actualData, searchValue);
        } else {
            type = 'reverse';
            Sorting(this.restoreData, type, this.state.actualData);
        }
    }

    fetchIconType = (e) => {
        if (e === this.state.sortingStatus.sortingName && this.state.sortingStatus.defaultDown) {
            return 'fas fa-chevron-down pointer ml-2 float-right'
        } else if (e === this.state.sortingStatus.sortingName && !this.state.sortingStatus.defaultDown) {
            return 'fas fa-chevron-up pointer ml-2 float-right'
        } else {
            return 'fas fa-chevron-down pointer ml-2 float-right icon-inactive'
        }
    }


    selectedLocationStatus = (selectedLocation, type) => {
        if (this.state.selectedLocation === selectedLocation && type === 'location') {
            return 'bolder'
        } else if (type === 'username' && this.state.selectedLocation === '') {
            return 'bolder'
        } else {
            return 'normal'
        }
    }

    userDatatable = () => {
        if (this.state.userData !== null) {
            let someData = this.state.userData.map((userElement, index) => {
                return (
                    <React.Fragment key={index}>
                        <tr key={index} className="some-hover" style={{ backgroundColor: this.state.siSelected === index ? '#F2F2E9' : '', fontSize: '12px' }}>
                            <th scope="col" style={{ width: '15%', wordBreak: 'break-word', textAlign: 'center', verticalAlign: 'middle', wordWrap: 'break-word' }}>{index + 1}</th>
                            <td scope="col" style={{ width: '15%', textAlign: 'center', verticalAlign: 'middle', wordBreak: 'break-word', wordWrap: 'break-word', }}> {userElement.name}</td>
                            <td scope="col" style={{ width: '15%', textAlign: 'center', verticalAlign: 'middle', wordBreak: 'break-word', wordWrap: 'break-word' }}>{userElement.role?.name}</td>
                            <td scope="col" style={{ width: '15%', textAlign: 'center', verticalAlign: 'middle', wordBreak: 'break-word', wordWrap: 'break-word' }}>{userElement.user_email}</td>
                            <td scope="col" style={{ width: '15%', textAlign: 'center', verticalAlign: 'middle', wordBreak: 'break-word', wordWrap: 'break-word' }}>{userElement.role_assigned}</td>
                            <td scope="col" style={{ width: '15%', textAlign: 'center', verticalAlign: 'middle', wordBreak: 'break-word', wordWrap: 'break-word' }}>{userElement.role_created_by}</td>
                            {(
                                localStorage.getItem("user_type") === "1" ||
                                (
                                    localStorage.getItem("user_type") === "2" &&
                                    is_allowed(this.props.redux.permissions.permissions, localStorage.getItem("user_type"), "user", "edit")
                                )
                            ) && (
                                    <td scope="col" style={{ width: '11%', verticalAlign: 'middle', wordBreak: 'break-word', wordWrap: 'break-word' }}>
                                        <div>
                                            {/* Edit Icon */}
                                            <span
                                                onClick={
                                                    (e) => {
                                                        if (this.state.modalIsOpenAddSIEdit) {
                                                            this.setState({ modalIsOpenAddSIEdit: false }, () => {
                                                                this.setState({
                                                                    modalIsOpenAddSIEdit: true,
                                                                    userCurrentData: userElement,
                                                                    siSelected: ''
                                                                })
                                                            })
                                                        } else {
                                                            this.setState({
                                                                modalIsOpenAddSIEdit: true,
                                                                userCurrentData: userElement
                                                            })
                                                        }
                                                    }}
                                            >
                                                <img src={editIcon} alt="" style={{ width: '12px', height: '16px', marginLeft: '15px' }} />
                                            </span>

                                            {/* Toggle Switch */}
                                            <span style={{ marginLeft: '10px' }}>
                                                <Switch
                                                    checked={userElement.status === 1}
                                                    onChange={() => {
                                                        this.onAddClickHandlerPUT(null, {
                                                            user_email: userElement.user_email,
                                                            currentStatus: userElement.status,
                                                        })
                                                    }}
                                                    color="primary"
                                                    size="small"
                                                />
                                            </span>
                                        </div>
                                    </td>)}
                        </tr>

                    </React.Fragment>
                )
            })
            return someData;
        }
        else {
            return null
        }
    }

    overlayShadowUnderModal = (type) => {
        if (type === 'overlay') {
            if (this.state.modalIsOpenAddSI || this.state.modalIsOpenAddSIView || this.state.modalIsOpenSIProject || this.state.modalIsOpenOkasBoxes || this.state.modalIsOpenAddSIEdit || this.state.modalIsOpenDeleteSuccess) {
                return (
                    <div style={{ position: 'absolute', height: `${window.innerHeight - 60}px`, width: `${window.innerWidth - 260}px`, backgroundColor: 'rgba(0,0,0,0.75)', zIndex: '0', display: '' }}></div>
                )
            } else {
                return null
            }
        } else if (type === 'scroll') {
            return 'hidden'
        } else if (type === 'siCurrentDataBlock') {
            if (this.state.modalIsOpenAddSI || this.state.modalIsOpenAddSIView || this.state.modalIsOpenSIProject || this.state.modalIsOpenOkasBoxes || this.state.modalIsOpenAddSIEdit || this.state.modalIsOpenDeleteSuccess) {
                return (
                    'none'
                )
            } else {
                return null
            }
        }
    }

    closeAllModal = (e) => {
        this.fetchUsers();
        this.setState({
            modalIsOpenAddSI: false,
            modalIsOpenAddSIView: false,
            modalIsOpenSIProject: false,
            modalIsOpenOkasBoxes: false,
            modalIsOpenAddSIEdit: false,
            modalIsOpenDelete: false,
        })
    }

    render() {
        return (
            <React.Fragment>
                {this.state.loader ? <Loader /> : null}
                {this.overlayShadowUnderModal('overlay')}
                <Tooltip />
                <Style>
                    {
                        `.atoB {
              position: relative;
              margin:14%
            }            
            .firstDot {
              position: absolute;
              top:  ${this.state.siProjectAddress.length === 0 ? '25%' : '6%'};
              left: 0;
              width: 10px;
              height: 10px;
              border-radius: 50%;
              background: #949494;
            }            
            .secondDott {
              position: absolute;
              top: 70%;
              left: 0;
              width: 10px;
              height: 10px;
              border-radius: 50%;
              background: #949494;
            }
            .text::before {
              content: '';
              border-left: 3px solid #949494;
              width: 10px;
              position: absolute;
              height: ${this.state.siProjectAddress.length === 0 ? '0%' : '86%'};
              top: 9.5%;
              left: 1.5%;
            }            
            .text {
              margin-bottom: 20%;
              margin-left: 10%;
              color: #757575
            }            
            .heading-part1{
              font-size: 1rem;
              color: #000;
            }
            .part2{
              font-size: .75rem;
            }`
                    }
                </Style>
                <div style={{ width: '100%', paddingLeft: '5px', paddingTop: '40px', paddingRight: '20px', }}>
                    {!this.props.redux.auth.searchBarShow ? <div style={{ marginBottom: '20px' }}>
                        <span style={{ color: '#888888', fontSize: '30px', }}>USER</span>
                        <span style={{ float: 'right' }}>
                            {!this.props.redux.auth.searchBarShow ? <div className="row" style={{ margin: '0' }}>
                                <div className="pointer" onClick={this.openModal} >
                                    {(
                                        localStorage.getItem("user_type") === "1" ||
                                        (
                                            localStorage.getItem("user_type") === "2" &&
                                            is_allowed(this.props.redux.permissions.permissions, localStorage.getItem("user_type"), "user", "add")
                                        )
                                    ) && (
                                            <div className="buttonContent" style={{ backgroundColor: 'white', boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2)' }}>
                                                {/* <Icon icon={iosPlusEmpty} size={40} style={{ color: "#F08100", backgroundColor: "none", }} /> */}
                                                <IconButton
                                                    //  sx={{color:'#F08100', outline:'none'}}
                                                    sx={{
                                                        color: '#F08100',
                                                        fontSize: 40,
                                                        backgroundColor: 'transparent',
                                                        '&:hover': {
                                                            backgroundColor: 'transparent'
                                                        },
                                                        '&:focus': {
                                                            outline: 'none',
                                                            border: 'none',
                                                            backgroundColor: 'transparent'
                                                        }
                                                    }}
                                                    aria-label="add">
                                                    <AddIcon sx={{ fontSize: 40 }} />
                                                </IconButton>
                                                <span style={{ color: '#888888', fontSize: '10px', fontWeight: '600' }}>ADD USER</span>
                                            </div>)}
                                </div>
                            </div> : null}
                        </span>
                    </div> : <div className='animated animated-duration-custom slideInDown pb-3 mt-2 flex-fill'>
                        <SearchBar autoFocus
                            value={this.state.searchValue}
                            onChange={(e) => {
                                this.setState({
                                    searchValue: e
                                }, () => {
                                    this.sortingFunc('search', this.state.searchValue)
                                })
                            }
                            }
                            onRequestSearch={() => this.sortingFunc('search', this.state.searchValue)}
                            resetSearch={(e) => {
                                this.setState({
                                    searchValue: e
                                }, () => {
                                    this.sortingFunc('search', '')
                                })
                            }}
                        /></div>}
                    <table className="table">
                        <thead className="tableHeaderColor" style={{ borderRadius: '10px 10px 0px 0px' }}>
                            {/* <th scope="col" style={{ width: '50px' }}></th> */}
                            <th scope="col" style={{ width: '15%', verticalAlign: 'middle', textAlign: 'center', fontSize: '13px' }}>
                                S.No
                                <i class={this.fetchIconType('si_id')} onClick={(e) => { this.sortingFunc('si_id') }}></i>
                            </th>
                            <th scope="col" style={{ width: '15%', verticalAlign: 'middle', textAlign: 'center', fontSize: '13px' }}>
                                Name
                                <i class={this.fetchIconType('si_name')} onClick={(e) => { this.sortingFunc('si_name') }}></i>
                            </th>
                            <th scope="col" style={{ width: '15%', verticalAlign: 'middle', textAlign: 'center', fontSize: '13px' }}>
                                Role
                                <i class={this.fetchIconType('si_name')} onClick={(e) => { this.sortingFunc('si_name') }}></i>
                            </th>
                            <th scope="col" style={{ width: '15%', verticalAlign: 'middle', textAlign: 'center', fontSize: '13px' }}>
                                Email
                                <i class={this.fetchIconType('si_name')} onClick={(e) => { this.sortingFunc('si_name') }}></i>
                            </th>
                            <th scope="col" style={{ width: '15%', verticalAlign: 'middle', textAlign: 'center', fontSize: '13px' }}>
                                Under User
                                <i class={this.fetchIconType('si_name')} onClick={(e) => { this.sortingFunc('si_name') }}></i>
                            </th>
                            <th scope="col" style={{ width: '15%', verticalAlign: 'middle', textAlign: 'center', fontSize: '13px' }}>
                                Created by
                                <i class={this.fetchIconType('si_company')} onClick={(e) => { this.sortingFunc('si_company') }}></i>
                            </th>
                            {(
                                localStorage.getItem("user_type") === "1" ||
                                (
                                    localStorage.getItem("user_type") === "2" &&
                                    is_allowed(this.props.redux.permissions.permissions, localStorage.getItem("user_type"), "user", "edit")
                                )
                            ) && (
                                    <th scope="col" style={{ width: '11%', verticalAlign: 'middle', fontSize: '13px' }}>
                                        Edit
                                    </th>)}
                        </thead>
                        <tbody style={{ maxHeight: `${window.innerHeight - 250}px`, overflowY: 'overlay' }}>
                            {this.userDatatable()}
                        </tbody>
                    </table>
                </div>
                {this.ActivateSIModel()}
                {this.ActivateSiModelView()}
                {this.ActivateUserModelEdit()}
                {this.renderTotalProject()}
                {this.renderTotalBoxes()}
                <div className="modal">
                    <DoughnutChart />
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        redux: state,
    };
};



const mapDispatchToProps = dispatch => {
    return {
        searchBarActivate: (data) => dispatch({ type: ActionTypes.SEARCHBAR, data: data }),
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(User);